import { sortArrayBy } from '@domain-group/javascript-utils'

import useLayoutTemplates from '@hooks/useLayoutTemplates'
import usePublicationBooking, { usePublicationBookingForm } from '@hooks/usePublicationBooking'
import usePublicationProducts from '@hooks/usePublicationProducts'

import type { PublicationBookingModel } from '@models/types'

function useCreateOrEditPublicationBookingModal(publicationBooking: PublicationBookingModel) {
  // Publication Booking
  const publicationBookingPayload = usePublicationBooking(publicationBooking)

  // Publication Booking Form
  const publicationBookingFormPayload = usePublicationBookingForm(publicationBooking, { validateOn: 'change' })
  const {
    entityState: {
      publication_id,
      publication_product_id,
    },
  } = publicationBookingFormPayload

  // Layout Templates
  const layoutTemplatesPayload = useLayoutTemplates({
    filters: {
      compatible_product_id: publication_product_id,
      publication_id,
    },
    performHttpRequests: false,
  })

  // Publication Products
  const publicationProductsPayload = usePublicationProducts({
    filters: {
      publication_id,
    },
    performHttpRequests: false,
  })

  const {
    filteredPublicationProducts,
  } = publicationProductsPayload

  return {
    layoutTemplatesPayload,
    publicationBookingPayload,
    publicationBookingFormPayload,
    publicationProductsPayload,
    sortedPublicationProducts: sortArrayBy(
      filteredPublicationProducts,
      'desc',
      ({ columns, rows }) => columns * rows,
    ),
  }
}

export default useCreateOrEditPublicationBookingModal
